/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CreateOrderResponse } from '../models/CreateOrderResponse';
import type { ParsedServiceBoxModel } from '../models/ParsedServiceBoxModel';
import type { PartAvailabilitySubmitModel } from '../models/PartAvailabilitySubmitModel';
import type { PartLookUpResult } from '../models/PartLookUpResult';
import type { PartOrderCard } from '../models/PartOrderCard';
import type { PartRequestAddressInputModel } from '../models/PartRequestAddressInputModel';
import type { PartRequestClientStatus } from '../models/PartRequestClientStatus';
import type { PartRequestCustomerInfo } from '../models/PartRequestCustomerInfo';
import type { PartRequestModel } from '../models/PartRequestModel';
import type { PartRequestType } from '../models/PartRequestType';
import type { PartRequestWipInfoInputModel } from '../models/PartRequestWipInfoInputModel';
import type { PartsStatus } from '../models/PartsStatus';
import type { StockPart } from '../models/StockPart';
import type { Titles } from '../models/Titles';
import type { WipInfoModel } from '../models/WipInfoModel';
import type { WipInfosInput } from '../models/WipInfosInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PartRequestService {

  /**
   * @param formData 
   * @returns number Created
   * @throws ApiError
   */
  public static postSavePartRequest(
formData?: {
'Customer.Title'?: string;
'Customer.TitleId'?: Titles;
'Customer.FirstName': string;
'Customer.LastName': string;
'Customer.Email': string;
'Customer.Phone': string;
'Customer.CDKCustomerId'?: string;
'Customer.FullName'?: string;
Description?: string;
RegNo: string;
BranchId?: number;
BranchCode?: string;
Id?: number;
Wip?: number;
Type?: PartRequestType;
ConcernType?: number;
SoHeaderId?: number;
RepairOrderQuoteId?: number;
TechnicianRepairId?: number;
SendEmailSMS?: boolean;
CustomerRequestStatus?: PartRequestClientStatus;
PhotosInputModels?: Array<Blob>;
},
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SavePartRequest',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param status
 *
 * 0 = All
 *
 * 1 = Active
 *
 * 2 = Closed
 *
 * 3 = Order
 *
 * 4 = Confirmed
 *
 * 5 = Completed
   * @param userId 
   * @returns any Success
   * @throws ApiError
   */
  public static putPartRequestsStatus(
id: number,
status?: PartsStatus,
userId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/part-requests/{id}/status',
      path: {
        'id': id,
      },
      query: {
        'status': status,
        'userId': userId,
      },
    });
  }

  /**
   * @param partRequestId 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postSavePartRequestWithNoPayment(
partRequestId?: number,
requestBody?: Array<WipInfosInput>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SavePartRequestWithNoPayment',
      query: {
        'partRequestId': partRequestId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSaveApplyPartRequestAddress(
requestBody?: PartRequestAddressInputModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveApplyPartRequestAddress',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns WipInfoModel Success
   * @throws ApiError
   */
  public static getGetPartRequests(
id?: number,
): CancelablePromise<Array<WipInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequests',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WipInfoModel Success
   * @throws ApiError
   */
  public static getGetPartRequestsWipInfo(
id?: number,
): CancelablePromise<WipInfoModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequestsWipInfo',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param partRequestId 
   * @param userId 
   * @param allParts 
   * @returns CreateOrderResponse Created
   * @throws ApiError
   */
  public static postCreateOrderCdk(
partRequestId?: number,
userId?: number,
allParts: boolean = false,
): CancelablePromise<CreateOrderResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateOrderCDK',
      query: {
        'partRequestId': partRequestId,
        'userId': userId,
        'allParts': allParts,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns PartOrderCard Success
   * @throws ApiError
   */
  public static getGetPartRequest(
id?: number,
): CancelablePromise<PartOrderCard> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequest',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wips 
   * @returns PartOrderCard Success
   * @throws ApiError
   */
  public static getGetPartOrderCart(
wips?: Array<number>,
): CancelablePromise<PartOrderCard> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartOrderCart',
      query: {
        'wips': wips,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param brandCode 
   * @param partNumber 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns PartLookUpResult Success
   * @throws ApiError
   */
  public static getPartRequestsPartsLookup(
brandCode: string,
partNumber: string,
branch?: BranchType,
): CancelablePromise<Array<PartLookUpResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-requests/parts/lookup',
      query: {
        'brandCode': brandCode,
        'partNumber': partNumber,
        'branch': branch,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param partNumber 
   * @returns PartLookUpResult Success
   * @throws ApiError
   */
  public static getPartRequestsPartsFind(
partNumber: string,
): CancelablePromise<Array<PartLookUpResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-requests/parts/find',
      query: {
        'partNumber': partNumber,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param partRequestId 
   * @returns PartRequestModel Success
   * @throws ApiError
   */
  public static getGetPartEnquiry(
partRequestId?: number,
): CancelablePromise<PartRequestModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartEnquiry',
      query: {
        'partRequestId': partRequestId,
      },
    });
  }

  /**
   * @param partRequestId 
   * @returns PartRequestCustomerInfo Success
   * @throws ApiError
   */
  public static getGetPartRequestCustomerInfo(
partRequestId?: number,
): CancelablePromise<PartRequestCustomerInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPartRequestCustomerInfo',
      query: {
        'partRequestId': partRequestId,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchPartRequestWipInfo(
id: number,
requestBody?: PartRequestWipInfoInputModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/PartRequest/{id}/wip-info',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWipInfo(
requestBody?: PartRequestWipInfoInputModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-info',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteWipInfo(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/wip-info/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteWipInfoSoftDelete(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/wip-info/{id}/soft-delete',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static postWipInfoRestore(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-info/{id}/restore',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns StockPart Success
   * @throws ApiError
   */
  public static postWipInfoCheckBranches(
id: number,
): CancelablePromise<Array<StockPart>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-info/{id}/check-branches',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns ParsedServiceBoxModel Success
   * @throws ApiError
   */
  public static getPartsAvailability(
id: number,
): CancelablePromise<ParsedServiceBoxModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/parts/{id}/availability',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postPartsAvailability(
id: number,
requestBody?: PartAvailabilitySubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/parts/{id}/availability',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postPartsBranchAvailability(
id: number,
requestBody?: Array<StockPart>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/parts/{id}/branch-availability',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
